import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import EArchiveGroupsListCreateModalForm from './EArchiveGroupsListCreateModalForm';

const EArchiveGroupsListCreateModal = (props: BaseModalProps) => {
	return (
		<BaseModal {...props} title='Založit skupinu'>
			<EArchiveGroupsListCreateModalForm onSubmit={props.onClose} />
		</BaseModal>
	);
};

export default EArchiveGroupsListCreateModal;
